import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AdminService } from '../../../../services/admin.service';
import {
  GeneralSetting,
  GeneralSettingEditableField,
  isAiGeneralSettingField,
  mergeGeneralSetting,
} from '../../../../models/general-setting.model';

@Component({
  selector: 'app-change-modal',
  templateUrl: './change-modal.component.html',
  styleUrls: ['./change-modal.component.css']
})

export class ChangeModalComponent implements OnInit {

  public id: string;
  public value: number = null;

  public disabledBtn = false;
  public successInfo = false;
  public errorInfo = false;
  action: GeneralSettingEditableField;
  title = '';
  obj: GeneralSetting;

  constructor(public activeModal: NgbActiveModal,
    private adminService: AdminService) {
  }

  ngOnInit() {
    this.obj = mergeGeneralSetting(this.obj);
    this.setInitialValue();
  }

  changeFour(value: number) {
    if (value < 0) {
      this.value = 0;
      return;
    }
    if (this.shouldLimitToHundred(value)) {
      this.value = 100;
    }
  }

  renameGroup() {
    if (this.disableBtnValidation()) {
      return;
    }
    this.obj[this.action] = this.value;
    this.disabledBtn = true;
    this.successInfo = false;
    this.errorInfo = false;
    this.adminService.changeModalSettings(this.obj).subscribe(
      () => {
        this.successInfo = true;
        this.errorInfo = false;
        this.disabledBtn = false;
        this.activeModal.close('ok');
      },
      () => {
        this.errorInfo = true;
      }
    );
  }

  disableBtnValidation() {
    return this.value === null;
  }

  private setInitialValue() {
    if (this.value !== null && typeof this.value !== 'undefined') {
      return;
    }
    this.value = this.obj[this.action];
  }

  private shouldLimitToHundred(value: number): boolean {
    if (isAiGeneralSettingField(this.action)) {
      return false;
    }
    return value > 100;
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-user-report/change-modal/change-modal.component.ts